import { getCachevalue } from './CacheProviderService';

/** Session `DoctorPatientData` fallback when Doctor Notes GETs run before React state has patient/appointment ids. */
export const doctorPatientDataCached = () => { try { return JSON.parse(getCachevalue('DoctorPatientData') || 'null'); } catch { return null; } };
export const qDoctorPatientId = (v) => v ?? doctorPatientDataCached()?.patient_id;
export const qDoctorAppointmentId = (v) => { const d = doctorPatientDataCached(); return v ?? d?.appointment_id ?? d?.appt_id; };
